// Resolves the active brand at build time from REACT_APP_BRAND.
//
// Anything other than the literal "6love" (including an unset var) falls back to
// the original Tennis Team Manager brand, so the default production build and the
// existing tests are unaffected.

import { Brand, TTM_BRAND, SIXLOVE_BRAND } from './brands';

export const BRAND: Brand =
  process.env.REACT_APP_BRAND === '6love' ? SIXLOVE_BRAND : TTM_BRAND;

export { Wordmark } from './Wordmark';
export type { Brand, BrandKey } from './brands';
